import React from "react";
import { marked } from "marked";

import './parseMessage.css';

export const ParseMessage = ({ message, className = '' }) => {
  // Parse markdown to HTML using marked
  const createMarkup = (text) => {
    try {
      return { __html: marked.parse(text || "") };
    } catch (error) {
      // Fallback to plain text if parsing fails
      return { __html: text || "" };
    }
  };

  // If message is a string, parse as markdown; otherwise render as React node
  if (typeof message === 'string') {
    return (
      <div
        className={`parseMessage ${className || ''}`}
        dangerouslySetInnerHTML={createMarkup(message)}
      />
    );
  }

  return (
    <div className={`parseMessage ${className || ''}`}>
      {message}
    </div>
  );
};
